var _a, _b;
import * as tslib_1 from "tslib";
import { handleActions } from 'redux-actions';
import { initialize, requestFailure, requestSuccess, spreadLove, requestSuccessWithRecommendations, } from './actionCreators';
import { defaultSliceState, reduxKey } from './constants';
function setDeviationState(state, payload, value) {
    var _a;
    if (!payload) {
        return state;
    }
    return tslib_1.__assign({}, state, (_a = {}, _a[payload.itemId] = tslib_1.__assign({}, defaultSliceState, state[payload.itemId], value), _a));
}
var actionHandlers = handleActions((_a = {},
    _a[initialize.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload
            ? setDeviationState(state, payload, {
                loveScore: payload.initialData.loveScore,
                loveCount: payload.initialData.loveCount,
            })
            : state;
    },
    _a[spreadLove.toString()] = function (state, _a) {
        var payload = _a.payload;
        if (!payload) {
            return state;
        }
        var slice = state[payload.itemId];
        var _b = slice || {}, stateLoveCount = _b.loveCount, stateLoveScore = _b.loveScore;
        var loveScore = payload.loveScore, _c = payload.loveCount, loveCount = _c === void 0 ? stateLoveCount || 0 : _c;
        var wasLove = stateLoveScore && stateLoveScore > 0;
        var isLove = loveScore > 0;
        var change = wasLove ? (isLove ? 0 : -1) : isLove ? 1 : 0;
        return setDeviationState(state, payload, {
            isLoading: true,
            loveScore: loveScore,
            loveCount: Math.max((loveCount || 0) + change, 0),
            undoState: {
                loveScore: stateLoveScore,
                loveCount: stateLoveCount,
            },
        });
    },
    _a[requestFailure.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload
            ? setDeviationState(state, payload, tslib_1.__assign({}, (state &&
                state[payload.itemId] &&
                state[payload.itemId].undoState), { isLoading: false, undoState: undefined }))
            : state;
    },
    _a[requestSuccess.toString()] = function (state, _a) {
        var payload = _a.payload;
        return payload
            ? setDeviationState(state, payload, {
                isLoading: false,
                undoState: undefined,
            })
            : state;
    },
    _a[requestSuccessWithRecommendations.toString()] = function (state, _a) {
        var payload = _a.payload;
        return setDeviationState(state, payload, {
            isLoading: false,
            undoState: undefined,
            suggestions: payload.recommendations,
        });
    },
    _a), {});
var reducers = (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map